import React from 'react';
import { Row, Col, Form, InputNumber, Switch, Typography } from 'antd';
import PropTypes from 'prop-types';
import { AlphaNumInput, RegexInput, NumberInput } from 'shared_components/pattern_input';
import { fieldRules, fieldLabels } from '../settings';
import DropDown from '../../shared/dropdown';
import { Select } from 'antd';

const InputForm = ({ sectionId, specimenId, ddRecords }) => {
	return (
		<div className="settings-exam-request-form">
			<Row gutter={12}>
				<Col span={24}>
					<Form.Item name="examRequestActive" valuePropName="checked" label="STATUS" initialValue={true}>
						<Switch disabled />
					</Form.Item>
				</Col>
				<Col span={9}>
					<Form.Item
						name="examRequestName"
						label={fieldLabels.examName}
						rules={fieldRules.examName}
					>
						<RegexInput regex={/[A-z0-9 -]/} maxLength={254} />
					</Form.Item>
				</Col>
				<Col span={10}>
					<Form.Item
						name="examRequestCode"
						label={fieldLabels.examCode}
						rules={fieldRules.examCode}
					>
						<AlphaNumInput maxLength={50} />
					</Form.Item>
				</Col>
				<Col span={5}>
					<Form.Item label="REPORT TEMPLATE" name="examRequestReportTemplate">
						<Select options={ddRecords} />
					</Form.Item>
				</Col>
				<Col span={4} className="hide">
					<Form.Item
						name="specimenID"
						label={fieldLabels.specimenID}
						rules={fieldRules.specimenID}
						initialValue={specimenId}
					>
						<InputNumber className="fullWidth" />
					</Form.Item>
				</Col>
				<Col span={4} className="hide">
					<Form.Item
						name="sectionID"
						label={fieldLabels.sectionID}
						rules={fieldRules.sectionID}
						initialValue={sectionId}
					>
						<InputNumber className="fullWidth" />
					</Form.Item>
				</Col>
			</Row>
			<Row gutter={12}>
				<Col span={9}>
					<Form.Item name="examRequestLoinc" label={fieldLabels.loinc} rules={fieldRules.loinc}>
						<AlphaNumInput maxLength={100} />
					</Form.Item>
				</Col>
				<Col span={10}>
					<Form.Item
						name="examRequestIntegrationCode"
						label={fieldLabels.integrationCode}
						rules={fieldRules.integrationCode}
					>
						<AlphaNumInput maxLength={100} />
					</Form.Item>
				</Col>
				<Col span={5}>
					{/* <Form.Item
						name="examRequestSort"
						label={fieldLabels.examSort}
						rules={fieldRules.examSort}
					>
						<NumberInput className="fullWidth" maxLength={32} />
					</Form.Item> */}
				</Col>
			</Row>

			<Row gutter={30}>
				<Col style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
					<Typography>STAT :</Typography>
					<Form.Item name="examRequestAutoSTAT" valuePropName="checked" style={{ margin: 0 }} initialValue={false}>
						<Switch />
					</Form.Item>
				</Col>

				<Col style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
					<Typography>AUTO SEND OUT :</Typography>
					<Form.Item name="examRequestAutoSendOut" valuePropName="checked" style={{ margin: 0 }} initialValue={false}>
						<Switch />
					</Form.Item>
				</Col>
			</Row>
		</div>
	);
};

InputForm.propTypes = {
	specimenId: PropTypes.number,
	sectionId: PropTypes.number,
};

InputForm.defaultProps = {
	specimenId: null,
	sectionId: null,
};

export default InputForm;
